import React, { useState } from "react";
import "../components/loader.css"

function Loader() {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      console.log("Form submitted successfully!");
    }, 35000);
  };

  return (
    <>
          {isLoading && (
              <div className="loader-overlay">
                  <div style={{ textAlign: "center" }}>
                      <div className="loader"></div>
                      <div className="loader-cont">
                          <h1>Loading,</h1>
                          <h1>PLease Wait......</h1>
                      </div>
                  </div>
              </div>
          )}

      <form onSubmit={handleSubmit}>
        {/* Your form fields */}
        <input type="text" placeholder="Doctor Name" required />
        <button type="submit">Submit Form</button>
      </form>
    </>
  );
}

export default Loader;
